<script setup lang="ts">
import { computed } from 'vue'
import { Distribution } from '@/enums/Distribution'
import { useCartStore } from "@/stores/useCartStore"
import { useSessionStore } from "@/stores/useSessionStore"
import Icon from "@/components/partials/Icon.vue"
import { formatPrice } from "@/utils/helpers"
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"

const { t } = useI18n()
const route = useRoute()

const cartStore = useCartStore()
const sessionStore = useSessionStore()

const isDelivery = computed<boolean>(() => sessionStore.distribution === Distribution.Delivery)
const hasFreeDelivery = computed<boolean>(() => cartStore.establishmentDistribution.free_delivery_starting_at !== null)
const dueBeforeFreeDelivery = computed<number>(() => cartStore.establishmentDistribution.free_delivery_starting_at - cartStore.basketInfo.costs.subtotal)

const hasMinimalOrderValue = computed<boolean>(() => cartStore.establishmentDistribution.minimal_order_value > 0)
const dueBeforeMinimalOrderValue = computed<number>(() => cartStore.basketInfo.minimal_order_value_left)

const showMinimalOrderValue = computed<boolean>(() => !String(route.name).endsWith('checkout'))
</script>

<template>
  <div class="free-delivery-notice-container"
       v-if="(showMinimalOrderValue && hasMinimalOrderValue && dueBeforeMinimalOrderValue > 0) || (isDelivery && hasFreeDelivery)">
    <div class="free-delivery-notice"
         data-hj-allow
         v-if="showMinimalOrderValue && hasMinimalOrderValue && dueBeforeMinimalOrderValue > 0">
      <Icon name="notice"/>
      {{ t('minimal_order_value_notice.text', { price: formatPrice(dueBeforeMinimalOrderValue) }) }}
    </div>

    <div class="free-delivery-notice"
         data-hj-allow
         v-if="!(hasMinimalOrderValue && dueBeforeMinimalOrderValue > 0) && isDelivery && hasFreeDelivery">
      <template v-if="dueBeforeFreeDelivery > 0">
        <Icon name="scooter-line"/>
        {{ t('free-delivery-notice.text', { price: formatPrice(dueBeforeFreeDelivery) }) }}
      </template>
      <template v-else>
        <Icon name="discount"/>
        {{ t('free-delivery-notice.meets-minimum') }}
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.free-delivery-notice-container {
  .free-delivery-notice {
    display:         flex;
    align-items:     center;
    justify-content: center;
    gap:             1rem;
    padding:         0.5rem;
    background-color: #f7f7f7;
  }
}
</style>
